<template>
  <div id="app">
    <router-view/>
    <Spinner v-show="$loading.isShow"
             :class="{'preloader-overlay--white': $loading.isWhite}"
    />
  </div>
</template>

<script>
    import {AUTHORIZATION} from './constants/constants'
    import Spinner from './components/Spinner';

    export default {
        name: 'app',
        async created() {
            await this.$store.dispatch('fetch', localStorage.getItem(AUTHORIZATION), {root: true})
                .then(data => {
                    if (data && data.success !== true) {
                        this.$toastr.error(data.message)
                        this.$router.push('/login')
                    }
                })
        },
        components: {
          Spinner
        }
    }
</script>

<style >
  @import '../node_modules/bootstrap/dist/css/bootstrap.css';
  @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
  @import 'assets/fontawesome-free/css/all.css';
  @import '../node_modules/vue-popperjs/dist/vue-popper.css';
  @import '../node_modules/gridstack/dist/gridstack.css';
  @import 'assets/css/main.css';
  @import 'assets/css/custom.css';
  @import 'assets/css/metisMenu.min.css';
</style>
